/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Checkbox, Divider, FormControlLabel, Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_redondo.svg'
import {TaskAlt} from "@mui/icons-material";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {theme} from "../../Tema";
import {useContext, useEffect, useState} from "react";
import {verificarMembresia} from "../../CodigoCliente/Funciones/verificarMembresia";
import {usuarioContext} from "../../App";
import {obtenerTotalContratosActivos} from "../../CodigoCliente/Activos/obtenerTotalContratosActivos";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import {obtenerTotalDepositos} from "../../CodigoCliente/Depositos/obtenerTotalDepositos";
import {obtenerTotalRendimientos} from "../../CodigoCliente/Rendimientos/obtenerTotalRendimientos";
import {realizarCompra} from "../../CodigoCliente/Compras/realizarCompra";
import {activarMembresia} from "../../CodigoCliente/Membresia/activarMembresia";
import RelojMembresiaActiva from "../Secciones/Componentes/RelojMembresiaActiva";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Dialogo_Membresia = ({cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {sCell} = useResponsive()
    const [cargando, setCargando] = useState(false)
    const [conDepositos, setConDepositos] = useState(false)
    const [conRendimientos, setConRendimientos] = useState(false)
    const [hayDinero, setHayDinero] = useState(false)
    const [activa, setActivas] = useState(false)
    const [totalActivos, setTotalActivos] = useState(0)
    const [totalDepositos, setTotalDepositos] = useState(0)
    const [totalRendimientos, setTotalRendimientos] = useState(0)
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })

    const clickSolo = () =>{
        setCargando(true)
        subirDatos().then(() =>{
            setConDepositos(false)
        })
    }


    const subirDatos = async () => {

        iniciarCarga('Realizando el pago')

        let saldo = totalActivos * 5 / 100
        let objPago = {
            conDepositos: 0,
            conRendimientos: 0
        }

        if (conDepositos) {

            if (totalDepositos >= saldo) {
                objPago.conDepositos = saldo
            } else {
                objPago.conDepositos = totalDepositos
            }

        }

        if (conRendimientos) {

            if (objPago.conDepositos >= saldo) {
                objPago.conRendimientos = 0
            } else {
                objPago.conRendimientos = saldo - objPago.conDepositos
            }

        }





        if (objPago.conDepositos > 0) {
            await realizarCompra({usuario: cData.usuario, desde: 'Deposito', valor: objPago.conDepositos})
            nuevoAviso({aviso: 'Pagado con Depósito'})
        }

        if (objPago.conRendimientos > 0) {
            await realizarCompra({usuario: cData.usuario, desde: 'Rendimientos', valor: objPago.conRendimientos})
            nuevoAviso({aviso: 'Pagado con Rendimientos'})
        }


        let dox = await activarMembresia({usuario: cData.usuario})
        if (dox.res) {
            terminar({aviso: 'Membresía activada con exito'})
            setTimeout(() =>{
                window.location.reload()
            },500)
        } else {
            terminar({aviso: 'Algo inesperado sucedio, comunícate con soporte: 001Mem', variante: 'Error'})
        }

        setCargando(false)

    }


    useEffect(() => {

        let totalMembresia = totalActivos * 5 / 100

        if (conDepositos && !conRendimientos) {
            setHayDinero(totalDepositos >= totalMembresia)
        } else if (!conDepositos && conRendimientos) {
            setHayDinero(totalRendimientos >= totalMembresia)
        } else if (conDepositos && conRendimientos) {
            let suma = totalDepositos + totalRendimientos
            setHayDinero(suma >= totalMembresia)
        } else {
            setHayDinero(false)
        }


    }, [conDepositos, conRendimientos]);


    useEffect(() => {
        setActivas(verificarMembresia(cData.usuario))
        obtenerTotalContratosActivos(cData.usuario.id).then((dox) => {
            //console.log(dox)
            setTotalActivos(dox)
        })

        obtenerTotalDepositos(cData.usuario.id).then((dox) => {
            setTotalDepositos(dox)
        })

        obtenerTotalRendimientos(cData.usuario.id).then((dox) => {
            setTotalRendimientos(dox)
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography>Estado</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -1}}>
                <Typography
                    sx={{
                        fontSize: 32,
                        fontWeight: 600,
                        color: activa ? theme.palette.primary.main : theme.palette.primary.main + 60
                    }}>{activa ? 'ACTIVA' : 'INACTIVA'}</Typography>
            </Grid>

            {
                activa || totalActivos <= 0 ?


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                        <RelojMembresiaActiva fecha={cData.usuario.fechaMembresia}/>
                    </Grid>

                    :


                    <>
                        <Grid container size={12} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 16}}>Total Activos:
                                        <span style={{
                                            fontWeight: 600,
                                            paddingLeft: 5
                                        }}>{formatoMonedaTabla(totalActivos, 2) + ' USD'}</span>
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 16}}>Valor de Membresía:
                                        <span style={{
                                            fontWeight: 600,
                                            paddingLeft: 5
                                        }}>{formatoMonedaTabla(totalActivos * 5 / 100, 2) + ' USD'}</span>
                                    </Typography>
                                </Grid>

                                <Divider sx={{width: '100%', mt: 1}}/>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                    <Typography>Pagar con?</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <FormControlLabel
                                        componentsProps={{
                                            typography: {
                                                sx: {fontSize: sCell ? 14 : 16, lineHeight: 1.1}
                                            }
                                        }}
                                        control={<Checkbox checked={conDepositos}
                                                           onChange={(e) => setConDepositos(!conDepositos)}
                                                           disabled={totalDepositos <= 0}/>}

                                        label={`Wallet Depósito ($${totalDepositos} USD disponibles)`}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 0 : -2}}>
                                    <FormControlLabel
                                        componentsProps={{
                                            typography: {
                                                sx: {fontSize: sCell ? 14 : 16, lineHeight: 1.1}
                                            }
                                        }}
                                        control={<Checkbox checked={conRendimientos}
                                                           onChange={(e) => setConRendimientos(!conRendimientos)}
                                                           disabled={totalRendimientos < 0}/>}
                                        label={`Rendimientos ($${totalRendimientos} USD disponibles)`}/>
                                </Grid>

                            </Grid>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 1 : 0}}>
                            {!hayDinero &&
                                <Typography sx={{fontWeight: 600, lineHeight: 1.1}}>No hay suficiente dinero en la
                                    selección</Typography>
                            }
                        </Grid>


                    </>}


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    loading={cargando}
                    disabled={!hayDinero}
                    onClick={() => clickSolo()}
                    startIcon={
                        <TaskAlt/>}>{`Activar Membresía ${formatoMonedaTabla(totalActivos * 5 / 100, 2)}`}</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Membresia


